/**
 * Client API pour /cee/inbox (reconciliation des PJ non rattachees).
 *
 * Separe de cee.js pour respect 200L max + cohesion module (toutes les routes
 * inbox concentrees ici).
 */

import { apiFetch } from './client.js';

/**
 * Liste les unmatched_attachment et low_confidence_classification non resolus.
 * @returns {Promise<Array<object>>}
 */
export async function getInbox() {
  return apiFetch('/cee/inbox');
}

/**
 * Affecte une PJ inbox a un dossier+docType.
 * @param {string} eventId
 * @param {{ dossierId: string, docType: string }} payload
 * @returns {Promise<object>}
 */
export async function affectAttachment(eventId, payload) {
  return apiFetch(`/cee/inbox/${eventId}/affect`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/**
 * Reclassifie une PJ comme un autre docType.
 * @param {string} eventId
 * @param {string} docType
 * @returns {Promise<object>}
 */
export async function reclassifyAttachment(eventId, docType) {
  return apiFetch(`/cee/inbox/${eventId}/reclassify`, {
    method: 'POST',
    body: JSON.stringify({ docType }),
  });
}

/**
 * Marque une PJ inbox comme ignoree (spam, payload.resolved=true).
 * @param {string} eventId
 * @returns {Promise<object>}
 */
export async function ignoreAttachment(eventId) {
  return apiFetch(`/cee/inbox/${eventId}/ignore`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

// inboxAttachmentPreviewUrl est une URL pure : extrait dans cee/lib/ceeUrls.js (testable).
export { inboxAttachmentPreviewUrl } from '../cee/lib/ceeUrls.js';

/**
 * Recherche client + mandataire combo (autocomplete inbox).
 * @param {string} query
 * @returns {Promise<Array<{ dossierId: string, clientName: string, mandataireCode: string }>>}
 */
export async function searchDossiersAutocomplete(query) {
  const qs = new URLSearchParams({ q: query }).toString();
  return apiFetch(`/cee/dossiers/search?${qs}`);
}
